import { Button, DatePicker, Form, FormInstance, Input, InputNumber, Select } from 'antd'
import dayjs from 'dayjs'
import UserSelect from './UserSelect'
import { ACTIVITY_OUTCOME_OPTIONS, ACTIVITY_TYPE_OPTIONS } from '../../models/outlet.modal'

type Props = {
    form: FormInstance
    outletId: string
    defaultActorUserId?: number
    onSubmit: (values: any) => void
    onCancel?: () => void
}

export default function ActivityForm({ form, outletId, defaultActorUserId, onSubmit, onCancel }: Props) {
    const handleFinish = (values: any) => {
        onSubmit({
            outletId,
            type: values.type,
            note: values.note || '',
            outcome: values.outcome || '',
            durationMinutes: values.durationMinutes != null ? Number(values.durationMinutes) : 0,
            actorUserId: Number(values.actorUserId),
            nextFollowupAt: values.nextFollowupAt ? dayjs(values.nextFollowupAt).toISOString() : undefined,
        })
    }

    return (
        <Form
            form={form}
            layout='vertical'
            initialValues={{ actorUserId: defaultActorUserId }}
            onFinish={handleFinish}
            autoComplete='off'
        >
            <Form.Item name='type' label='Loại tương tác' rules={[{ required: true, message: 'Vui lòng chọn loại tương tác!' }]}>
                <Select options={ACTIVITY_TYPE_OPTIONS} placeholder='Chọn loại' />
            </Form.Item>
            <Form.Item name='actorUserId' label='Nhân sự thực hiện' rules={[{ required: true, message: 'Vui lòng chọn nhân sự!' }]}>
                <UserSelect placeholder='Chọn nhân sự' />
            </Form.Item>
            <Form.Item name='outcome' label='Kết quả'>
                <Select allowClear options={ACTIVITY_OUTCOME_OPTIONS} placeholder='Chọn kết quả' />
            </Form.Item>
            <Form.Item name='durationMinutes' label='Thời lượng (phút)'>
                <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
            <Form.Item name='nextFollowupAt' label='Hẹn tương tác tiếp theo'>
                <DatePicker showTime style={{ width: '100%' }} format='DD/MM/YYYY HH:mm' />
            </Form.Item>
            <Form.Item name='note' label='Ghi chú' rules={[{ required: true, message: 'Vui lòng nhập ghi chú!' }]}>
                <Input.TextArea rows={4} />
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                {onCancel && <Button onClick={onCancel}>Huỷ</Button>}
                <Button type='primary' htmlType='submit'>Thêm</Button>
            </div>
        </Form>
    )
}
